<!--<div class="range-calendar">-->
<!--  <ng-container *ngIf="{range: (range$ | async)} as streams$">-->
<!--    <div class="range-calendar__from">-->
<!--      <int-calendar-->
<!--        (onChange)="fromEventHandler($event)"-->
<!--        [currentDate]="streams$.range?.from || null"-->
<!--      ></int-calendar>-->
<!--    </div>-->
<!--    <int-empty-divider size="1rem"></int-empty-divider>-->
<!--    <div class="range-calendar__to">-->
<!--      <int-calendar-->
<!--        (onChange)="toEventHandler($event)"-->
<!--        [currentDate]="streams$.range?.to || null"-->
<!--      ></int-calendar>-->
<!--    </div>-->
<!--  </ng-container>-->
<!--</div>-->
